module.exports = __webpack_public_path__ + "static/media/wokloadingscreen.5979d4cd.gif";


//////////////////
// WEBPACK FOOTER
// ./src/app/images/background/wokloadingscreen.gif
// module id = ./src/app/images/background/wokloadingscreen.gif
// module chunks = 0